export default {
    Metadata: {
        Name: "Ascii",
        Description: "Returns the Ascii code for a given string character.",
        Syntax: "Ascii(character)",
        Keywords: ['String', 'Text'],
        Author: "DataVoke, Inc.",
    },
    execute(c) {
        if (c == undefined) {
            return -1;
        }
        if (typeof c != "string") {
            c = c.toString();
        }
        if (c.length == 0) {
            return -1;
        }
        return c.charCodeAt(0);
    },
};

